import { ITransactionFilterDto } from "../interfaces/filters/ITransactionFilterDto";
import { IGlobalAction } from "../interfaces/states/IGlobalAction";

export const transactionFilterInitialState: ITransactionFilterDto = {
    initialDate: null,
    endDate: null,
    transactionType: null,
    walletIdList: [],
    cryptoCurrencyIdList: []
}

export function transactionFiltersReducer(state: ITransactionFilterDto, action: IGlobalAction): ITransactionFilterDto {
    switch (action.type) {
        case 'SET_TRANSACTION_FILTERS':
            return {...state, ...action.payload};
        case 'RESET_TRANSACTION_FILTERS':
            return transactionFilterInitialState;
        default: 
            return state;
    }
}